import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Search } from 'lucide-react';
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import './Referral.scss';
import Sidebar from '../Sidebar';
import Header from '../../component/loaderComponent/Header/Header';
import Loader from '../../component/loaderComponent/loaderComponent/Loader';
import { fetchReferralList } from '../../actions/referralAction';
import { Image_Url } from '../../ImageUrl/ImageUrl';
import { HiMenu, HiX } from "react-icons/hi";
import useMobileView from "../../constants/useMobileView";
import NoDataFound from '../../component/noDataComponent/NoDataFound';

const ReferralManagement = () => {
    const dispatch = useDispatch();
    const { loading, referralData, error } = useSelector((state) => state.ReferralListReducer);
    const referrals = referralData?.results || [];
    const totalItems = referralData?.count || 0;
    const { isSidebarOpen, toggleSidebar } = useMobileView();
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [statusFilter, setStatusFilter] = useState("all");
    const [filters, setFilters] = useState({});
    const [searchCriteria, setSearchCriteria] = useState('');
    const [searchInput, setSearchInput] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');

    useEffect(() => {
        dispatch(fetchReferralList(page, pageSize, filters));
    }, [dispatch, filters, page, pageSize]);

    const handleSearch = () => {
        const newFilters = { ...(statusFilter !== "all" ? { status: statusFilter } : {}) };

        if (searchInput) {
            // if (searchCriteria === "Customer Id") newFilters.customer_name = searchInput;
            if (searchCriteria === "Dealer Id") newFilters.dealer_id = searchInput;
            if (searchCriteria === "PGM Id") newFilters.pgm_id = searchInput;
        }
        if (fromDate) newFilters.from_date = fromDate;
        if (toDate) newFilters.to_date = toDate;

        if (statusFilter !== "all") newFilters.status = statusFilter;

        setFilters(newFilters);
        setPage(1);
    };

    const handleStatusFilterChange = (status) => {
        setStatusFilter(status);
        setPage(1);

        setFilters((prevFilters) => ({
            ...prevFilters,
            status: status === "all" ? undefined : status,
        }));
        setSearchInput('');
        setSearchCriteria('');
        setFromDate('');
        setToDate('');
    };

    useEffect(() => {
        if (!searchInput && !fromDate && !toDate) {
            setFilters({ ...(statusFilter !== "all" ? { status: statusFilter } : {}) });
            setPage(1);
        }
    }, [searchInput, fromDate, toDate, statusFilter]);

    useEffect(() => {
        if (searchCriteria === "" && searchInput === "") {
            setFilters((prevFilters) => ({
                ...(statusFilter !== "all" ? { status: statusFilter } : {}),
            }));
            setPage(1);
        }
    }, [searchCriteria, searchInput, statusFilter]);

    useEffect(() => {
        if (!searchInput) {
            setSearchCriteria("");
        }
    }, [searchInput]);

    const handlePaginationChange = (event, value) => {
        setPage(value);
    };

    const today = new Date().toISOString().split("T")[0];
    return (
        <div className="referralMainContainer">
            <div className="referralConatiner">
                <div className="referralSubConatiner">
                    <div className="referralSubBoxConatiner">
                        <Header title="Referral" />
                        {loading ? (
                            <Loader />
                        ) : (
                            <>
                                <div className="container">
                                    <div className="filter-buttons">
                                        <div className='section-tab-btn'>
                                            <button
                                                className={`filter-btn ${statusFilter === 'all' ? 'active' : ''}`}
                                                onClick={() => handleStatusFilterChange('all')}
                                            >
                                                All
                                            </button>
                                            <button
                                                className={`filter-btn ${statusFilter === 'open' ? 'active' : ''}`}
                                                onClick={() => handleStatusFilterChange('open')}
                                            >
                                                Open
                                            </button>
                                            <button
                                                className={`filter-btn ${statusFilter === 'close' ? 'active' : ''}`}
                                                onClick={() => handleStatusFilterChange('close')}
                                            >
                                                Closed
                                            </button>
                                            <button
                                                className={`filter-btn ${statusFilter === 'lost' ? 'active' : ''}`}
                                                onClick={() => handleStatusFilterChange('lost')}
                                            >
                                                Lost
                                            </button>
                                        </div>
                                        <div className='download-excel-btn'>
                                            <button className='download-btn'>
                                                <img src={Image_Url.EXCEL_LOGO} className="downloads_imgdexcel" />
                                                Download Excel
                                            </button>
                                        </div>

                                    </div>

                                    <div className="search-section">
                                        <div className='date-selection'>
                                            <label className='from-date-label'>From Date</label>
                                            <input type="date" className="from-date-input" max={today} value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
                                        </div>

                                        <div className='date-selection'>
                                            <label className='to-date-label'>To Date</label>
                                            <input type="date" className="to-date-input" min={fromDate} max={today} value={toDate} onChange={(e) => setToDate(e.target.value)} />
                                        </div>
                                        <select className="sel-criteria" value={searchCriteria} onChange={(e) => setSearchCriteria(e.target.value)}>
                                            <option value="">Select Criteria</option>
                                            {/* <option value="Customer Name">Customer Name</option> */}
                                            <option value="Dealer Id">Dealer Id</option>
                                            <option value="PGM Id">PGM Id</option>
                                        </select>

                                        <div className="search-container">
                                            <input
                                                type="text"
                                                placeholder="Enter search criteria"
                                                className="sear-input"
                                                value={searchInput}
                                                onChange={(e) => {
                                                    const numericValue = e.target.value.replace(/[^0-9]/g, '');
                                                    setSearchInput(numericValue);
                                                }}
                                            />
                                            <Search className="search-icon" />
                                        </div>
                                        <div className='input-date-search-btn'>
                                            <button className="search-referal-btn" onClick={handleSearch}>Search</button>
                                        </div>
                                    </div>
                                    <div className="table-container">
                                        {referrals.length > 0 ? (
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th>S.No</th>
                                                        <th>PGM Id</th>
                                                        <th>Dealer Id</th>
                                                        <th>Customer Name</th>
                                                        <th>Referral Id</th>
                                                        <th>Status</th>
                                                        <th>Referral Date</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {referrals?.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>{(page - 1) * pageSize + index + 1}</td>
                                                            <td>{item?.pgm_id} - {item?.pgm_name || "N/A"}</td>
                                                            <td>{item?.dealer_id}</td>
                                                            <td className="referral-name" title={item?.customer_name}>{item?.customer_name}</td>
                                                            <td>{item?.refferal_id}</td>
                                                            <td>
                                                                <span className={`status ${item?.status?.toLowerCase() || "unknown"}`}>
                                                                    {item?.status || "N/A"}
                                                                </span>
                                                            </td>
                                                            <td>{new Date(item?.referral_date).toLocaleDateString()}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        ) : (
                                            <div>
                                                <NoDataFound />
                                            </div>
                                        )}
                                    </div>
                                    <div className="Pagination_section">
                                        {referrals?.length > 0 && (
                                            <Stack spacing={2}>
                                                <Pagination
                                                    count={Math.ceil(totalItems / pageSize)}
                                                    className="pagination"
                                                    page={page}
                                                    size="medium"
                                                    defaultPage={1}
                                                    color="primary"
                                                    onChange={handlePaginationChange}
                                                />
                                            </Stack>
                                        )}
                                        <div className="count">
                                            <b>
                                                <span>Displaying {(page - 1) * pageSize + 1} to {Math.min(page * pageSize, totalItems)} out of {totalItems}
                                                </span>
                                            </b>
                                        </div>

                                    </div>
                                </div>

                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReferralManagement;